import { Outlet } from "react-router-dom"
import { useLayoutStore } from "@/stores/useLayoutStore"
import { SlideDirectionTransition } from "../transitions/SlideTransition"

export function MainContent() {
  const hideBottomNav = useLayoutStore((state) => state.hideBottomNav)

  return (
    <main>
      <div 
        className={`bg-dark p-2 ${
          hideBottomNav 
            ? "h-[calc(100vh-3.5rem)]" // 3.5rem = header only
            : "h-[calc(100vh-7.5rem)]" // 7.5rem = header(3.5rem) + bottom-nav(4rem)
        }`}
      >
        <div className="container bg-background max-w-screen-2xl py-6 pt-2 px-1 rounded-t-xl h-full overflow-clip">
          <SlideDirectionTransition slideDistance={30} duration={250}>
            <Outlet />
          </SlideDirectionTransition>
        </div>
      </div>
    </main>
  )
} 